import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Bell, BellRing, CalendarClock, Car, Cake, CheckCircle2, Eye, FileSignature, Mail, MailWarning, RefreshCw, Trash2 } from "lucide-react";

const KIND_ICONS = { email: Mail, "email-failed": MailWarning, "quote-view": Eye, "quote-choice": CheckCircle2, "quote-new": FileSignature, appointment: CalendarClock, renewal: RefreshCw, inspection: Car, birthday: Cake };
import { API } from "../lib/apiClient";

const kindOf = (n) => (n.kind && n.kind !== "info" ? n.kind : /teklif seçti|notunu güncelledi/.test(n.title) ? "quote-choice" : "info");

export function NotificationsBell({ onNavigate }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const load = () => axios.get(`${API}/notifications`).then(({ data }) => setItems(data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  const unread = items.filter((n) => !n.read).length;
  const toggle = () => {
    setOpen((o) => !o);
    if (!open && unread) { axios.post(`${API}/notifications/read-all`).catch(() => {}); setTimeout(() => setItems((x) => x.map((n) => ({ ...n, read: true }))), 1500); }
  };
  const total = unread;
  const clear = () => {
    if (!window.confirm("Tüm bildirimler silinsin mi?")) return;
    axios.delete(`${API}/notifications`).then(() => setItems([])).catch(() => {});
  };
  return (
    <div className="nb" ref={ref}>
      <button type="button" className="icon-button notifications-btn" data-testid="notifications-button" onClick={toggle} title="Bildirimler">
        <Bell size={18} />
        {total > 0 && <span className="notification-badge" data-testid="notification-badge">{total}</span>}
      </button>
      {open && (
        <div className="nb-panel" data-testid="notifications-panel">
          <div className="nb-head"><strong>Bildirimler</strong>{items.length > 0 && <button type="button" onClick={clear} data-testid="notifications-clear"><Trash2 size={13} /> Temizle</button>}</div>
          <div className="nb-list">
          {items.length === 0 ? <p className="nb-empty">Henüz bildirim yok</p> : items.map((n) => (
            <button type="button" key={n.id} className={`nb-item${n.read ? "" : " unread"}`} onClick={() => { setOpen(false); onNavigate(n.url); }} data-testid={`notification-${n.id}`}>
              <i className={`nb-ico k-${kindOf(n)}`}>{(() => { const I = KIND_ICONS[kindOf(n)] || BellRing; return <I size={15} />; })()}</i>
              <div><strong>{n.title}</strong>{n.body && <span>{n.body}</span>}<em>{new Date(n.createdAt).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" })}</em></div>
            </button>
          ))}
          </div>
        </div>
      )}
    </div>
  );
}
